import 'slick-carousel';

// Variable Declaration
const $carousel = $('.js-carousel');

// Initialization carousel
$carousel.slick({
  prevArrow: '<button class="arrow arrow-prev"></button>',
  nextArrow: '<button class="arrow arrow-next"></button>',
});
